<template>
    <div class="relative w-10 h-22px cursor-pointer">
        <img class="w-10 h-22px" src="@/assets/image/button-off-brown.svg" @click="toggle()" />
        <img v-show="modelValue" class="absolute top-0 left-0 w-10 h-22px" src="@/assets/image/button-on-brown.svg"
            @click="toggle()" />
    </div>
</template>
<script>
export default {
    name: 'Switcher',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue"],
    methods: {
        toggle: function () {
            console.log(!this.modelValue);
            this.$emit("update:modelValue", !this.modelValue)
        }
    }
}
</script>
